import { fmtCurrency } from "../../utils/helpers";

export default function OrderTable({ data }) {
	let subtotal = 0;
	let fee = 0;
	let total = 0;

	return (
		<div className="receipt" style={{ marginTop: "0" }}>
			<table className="order">
				<thead>
					<tr>
						<th style={{ width: "10%" }}>Qty</th>
						<th className="left">Item</th>
						<th style={{ width: "20%" }}>Amount</th>
					</tr>
				</thead>
				{data.length > 0 ? (
					<tbody>
						{data.map((item) => {
							subtotal = item.amount;
							fee = subtotal * 0.03;
							total = total + subtotal + fee;

							return (
								<tr key={item.id}>
									<td className="center">
										<span>1</span>
									</td>
									<td>
										<div>
											<span style={{ fontWeight: "400" }}>{item.name}</span>
											<small style={{ paddingTop: "3px" }}>
												{item.description}
											</small>
										</div>
									</td>
									<td className="right">{fmtCurrency(subtotal / 100)}</td>
								</tr>
							);
						})}
					</tbody>
				) : (
					<tbody>
						<tr>
							<td colSpan="3">
								<span style={{ color: "#aaa" }}>
									No membership level selected
								</span>
							</td>
						</tr>
					</tbody>
				)}
				<tfoot>
					{/* don't show on this page <tr>
						<td colSpan="2" className="right">
							3% Processing Fee
						</td>
						<td className="right">{fmtCurrency(fee / 100)}</td>
					</tr>*/}
					<tr>
						<td colSpan="2" className="right" style={{ paddingTop: "12.5px" }}>
							<span style={{ fontWeight: "400", fontSize: "120%" }}>TOTAL</span>
						</td>
						<td className="right" style={{ paddingTop: "12.5px" }}>
							<span style={{ fontWeight: "400", fontSize: "120%" }}>
								{fmtCurrency(subtotal / 100)}
							</span>
						</td>
					</tr>
				</tfoot>
			</table>
		</div>
	);
}
